import moment from 'moment'

export function nullValueInObj(obj) {
  for (const key in obj) {
    obj[key] = null
  }
}

export function displayDate(data, format = 'DD/MM/YYYY') {
  if (data) {
    return moment(data).format(format)
  } else {
    return null
  }
}

export function displayCurrency(data, unit = 'en') {
  // default en
  if (data !== null && data !== undefined) {
    return Number(data).toLocaleString(unit)
  }
  return null
}

export function compareTime(from, to, msg = null) {
  if (from > to) {
    this.$message({
      type: 'error',
      message: msg || this.$t('errorMsg.timeError')
    })
    return false
  } else {
    return true
  }
}

export function checkAuthorized(param) {
  const string = localStorage.getItem('authorizedList')
  const authorizedList = JSON.parse(string)
  if (authorizedList.includes(param)) {
    return true
  } else {
    return false
  }
}

let timer
export function debounceFn(fn, delay) {
  clearTimeout(timer)
  timer = setTimeout(() => {
    fn()
    timer = null
  }, delay)
}

export const isBase64 = value =>
  /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{4})$/.test(
    value
  )
